'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes3 = require('./utils/propTypes');

var _accessors = require('./utils/accessors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  event: _propTypes2.default.object.isRequired,
  // @Appointment field info declaration
  patientNameAccessor: _propTypes3.accessor,
  clinicianImageAccessor: _propTypes3.accessor,
  clinicianNameAccessor: _propTypes3.accessor,
  appointmentTypeAccessor: _propTypes3.accessor,
  appointmentTimeAccessor: _propTypes3.accessor,
  isBillableAccessor: _propTypes3.accessor,
  appointmentAddressAccessor: _propTypes3.accessor,
  coPayAccessor: _propTypes3.accessor,
  soapNoteTitleAccessor: _propTypes3.accessor,
  setProfileTitleAccessor: _propTypes3.accessor,
  staffsAccessor: _propTypes3.accessor,
  isRecurrenceAccessor: _propTypes3.accessor,
  isRecurrenceEditAccessor: _propTypes3.accessor,
  isEditAccessor: _propTypes3.accessor,
  isDeleteAccessor: _propTypes3.accessor,
  isCancelAccessor: _propTypes3.accessor,
  isUnCancelAccessor: _propTypes3.accessor,
  isApproveAccessor: _propTypes3.accessor,
  cancellationReasonAccessor: _propTypes3.accessor,
  appointmentNotesAccessor: _propTypes3.accessor,
  isAppointmentRenderedAccessor: _propTypes3.accessor,
  isClientCheckedInAccessor: _propTypes3.accessor,
  isVideoCallAccessor: _propTypes3.accessor,
  isAppoinmentCancelledAccessor: _propTypes3.accessor,
  isMakeUpSessionAccessor: _propTypes3.accessor,
  isExcludedFromPayrollAccessor: _propTypes3.accessor,
  isExcludedFromMileageAccessor: _propTypes3.accessor,
  isRBTTrackingAccessor: _propTypes3.accessor,
  practitionerNameAccessor: _propTypes3.accessor,
  statusNameAccessor: _propTypes3.accessor,

  allDayAccessor: _propTypes3.accessor,
  startAccessor: _propTypes3.accessor,
  endAccessor: _propTypes3.accessor,

  // custom proptyes
  popupClassName: _propTypes2.default.string,
  hoverDialogActions: _propTypes2.default.func
};

var AppointmentBox = function (_React$Component) {
  _inherits(AppointmentBox, _React$Component);

  function AppointmentBox() {
    var _temp, _this, _ret;

    _classCallCheck(this, AppointmentBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderStaffs = function (staffs) {
      if (staffs) {
        return staffs.map(function (obj, index) {
          return _react2.default.createElement(
            'div',
            { className: 'info-p', key: index },
            _react2.default.createElement('img', { src: obj.image, width: '35px', height: '35px' }),
            _react2.default.createElement(
              'p',
              null,
              obj.staffName
            )
          );
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AppointmentBox.prototype.render = function render() {
    var _props = this.props,
        popupClassName = _props.popupClassName,
        event = _props.event,
        clinicianImageAccessor = _props.clinicianImageAccessor,
        clinicianNameAccessor = _props.clinicianNameAccessor,
        appointmentTypeAccessor = _props.appointmentTypeAccessor,
        appointmentTimeAccessor = _props.appointmentTimeAccessor,
        isBillableAccessor = _props.isBillableAccessor,
        appointmentAddressAccessor = _props.appointmentAddressAccessor,
        soapNoteTitleAccessor = _props.soapNoteTitleAccessor,
        staffsAccessor = _props.staffsAccessor,
        isRecurrenceAccessor = _props.isRecurrenceAccessor,
        isRecurrenceEditAccessor = _props.isRecurrenceEditAccessor,
        isEditAccessor = _props.isEditAccessor,
        isDeleteAccessor = _props.isDeleteAccessor,
        isCancelAccessor = _props.isCancelAccessor,
        isUnCancelAccessor = _props.isUnCancelAccessor,
        isApproveAccessor = _props.isApproveAccessor,
        cancellationReasonAccessor = _props.cancellationReasonAccessor,
        appointmentNotesAccessor = _props.appointmentNotesAccessor,
        isAppointmentRenderedAccessor = _props.isAppointmentRenderedAccessor,
        isClientCheckedInAccessor = _props.isClientCheckedInAccessor,
        isVideoCallAccessor = _props.isVideoCallAccessor,
        isAppoinmentCancelledAccessor = _props.isAppoinmentCancelledAccessor,
        isMakeUpSessionAccessor = _props.isMakeUpSessionAccessor,
        isExcludedFromPayrollAccessor = _props.isExcludedFromPayrollAccessor,
        isExcludedFromMileageAccessor = _props.isExcludedFromMileageAccessor,
        isRBTTrackingAccessor = _props.isRBTTrackingAccessor,
        statusNameAccessor = _props.statusNameAccessor,
        practitionerNameAccessor = _props.practitionerNameAccessor,
        hoverDialogActions = _props.hoverDialogActions;


    var clinicianImage = (0, _accessors.accessor)(event, clinicianImageAccessor)
    //   , patientName = get(event, patientNameAccessor)
    ,
        clinicianName = (0, _accessors.accessor)(event, clinicianNameAccessor),
        appointmentType = (0, _accessors.accessor)(event, appointmentTypeAccessor),
        appointmentTime = (0, _accessors.accessor)(event, appointmentTimeAccessor),
        isBillable = (0, _accessors.accessor)(event, isBillableAccessor),
        appointmentAddress = (0, _accessors.accessor)(event, appointmentAddressAccessor)
    //   , coPay = get(event, coPayAccessor)
    ,
        soapNoteTitle = (0, _accessors.accessor)(event, soapNoteTitleAccessor)
    //   , setProfileTitle = get(event, setProfileTitleAccessor)
    ,
        staffs = (0, _accessors.accessor)(event, staffsAccessor),
        isRecurrence = (0, _accessors.accessor)(event, isRecurrenceAccessor),
        isRecurrenceEdit = (0, _accessors.accessor)(event, isRecurrenceEditAccessor),
        isEdit = (0, _accessors.accessor)(event, isEditAccessor),
        isDelete = (0, _accessors.accessor)(event, isDeleteAccessor),
        isCancel = (0, _accessors.accessor)(event, isCancelAccessor),
        isApprove = (0, _accessors.accessor)(event, isApproveAccessor),
        isUnCancel = (0, _accessors.accessor)(event, isUnCancelAccessor),
        cancellationReason = (0, _accessors.accessor)(event, cancellationReasonAccessor),
        appointmentNotes = (0, _accessors.accessor)(event, appointmentNotesAccessor),
        practitionerName = (0, _accessors.accessor)(event, practitionerNameAccessor),
        isAppointmentRendered = (0, _accessors.accessor)(event, isAppointmentRenderedAccessor),
        isClientCheckedIn = (0, _accessors.accessor)(event, isClientCheckedInAccessor),
        isVideoCall = (0, _accessors.accessor)(event, isVideoCallAccessor),
        isAppoinmentCancelled = (0, _accessors.accessor)(event, isAppoinmentCancelledAccessor),
        isMakeUpSession = (0, _accessors.accessor)(event, isMakeUpSessionAccessor),
        isExcludedFromPayroll = (0, _accessors.accessor)(event, isExcludedFromPayrollAccessor),
        isExcludedFromMileage = (0, _accessors.accessor)(event, isExcludedFromMileageAccessor),
        isRBTTracking = (0, _accessors.accessor)(event, isRBTTrackingAccessor),
        statusName = (0, _accessors.accessor)(event, statusNameAccessor);

    var appointmentStatusClass = 'default_ap';
    switch ((statusName || '').toUpperCase()) {
      case 'PENDING':
        appointmentStatusClass = 'pending_ap';
        break;
      case 'APPROVED':
        appointmentStatusClass = 'approved_ap';
        break;
      case 'CANCELLED':
        appointmentStatusClass = 'cancelled_ap';
        break;
      case 'RENDERED':
        appointmentStatusClass = 'rendered_ap';
        break;
      default:
        appointmentStatusClass = 'default_ap';
    }

    statusName = (statusName || '').toUpperCase() === 'PENDING' ? statusName.charAt(0).toUpperCase() + statusName.slice(1) : '';

    return _react2.default.createElement(
      'div',
      { className: popupClassName },
      _react2.default.createElement(
        'div',
        { className: 'topbar ' + appointmentStatusClass },
        _react2.default.createElement(
          'div',
          { className: 'info-title' },
          'Appointment ',
          !statusName && 'info',
          ' ',
          statusName && _react2.default.createElement(
            'small',
            null,
            '(',
            statusName,
            ')'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'icons' },
          _react2.default.createElement(
            'ul',
            null,
            isRecurrenceEdit ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { title: 'Edit recurrence', className: 'edit', href: '#', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'edit_recurrence');
                  } },
                _react2.default.createElement('i', { className: 'fa fa-repeat', 'aria-hidden': 'true' })
              )
            ) : '',
            isApprove ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { title: 'Approve', className: 'edit', href: '#', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'approve');
                  } },
                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' })
              )
            ) : '',
            isCancel ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { title: 'Cancel', className: 'edit', href: '#', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'cancel');
                  } },
                _react2.default.createElement('i', { className: 'fa fa-ban', 'aria-hidden': 'true' })
              )
            ) : isUnCancel ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { title: 'Undo Cancel', className: 'edit', href: '#', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'uncancel');
                  } },
                _react2.default.createElement('i', { className: 'fa fa-undo', 'aria-hidden': 'true' })
              )
            ) : '',
            isEdit ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { title: 'Edit', className: 'edit', href: '#', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'edit');
                  } },
                _react2.default.createElement('i', { className: 'fa fa-pencil-square-o', 'aria-hidden': 'true' })
              )
            ) : '',
            isDelete ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { title: 'Delete', className: 'trash', href: '#', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'delete');
                  } },
                _react2.default.createElement('i', { className: 'fa fa-trash-o', 'aria-hidden': 'true' })
              )
            ) : ''
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'info-content' },
        _react2.default.createElement(
          'div',
          { className: 'personal-info' },
          _react2.default.createElement(
            'div',
            { className: 'boxicon' },
            isRecurrence ? _react2.default.createElement('i', { title: 'Recurrence Appointment', className: 'fa fa-repeat', 'aria-hidden': 'true' }) : '',
            isAppointmentRendered ? _react2.default.createElement('i', { title: 'Rendered Appointment', className: 'fa fa-check-circle-o', 'aria-hidden': 'true' }) : '',
            isVideoCall ? _react2.default.createElement('i', { title: 'Video Call in Appointment', className: 'fa fa-video-camera', 'aria-hidden': 'true' }) : '',
            isAppoinmentCancelled ? _react2.default.createElement('i', { title: '' + cancellationReason, className: 'fa fa-ban', 'aria-hidden': 'true' }) : '',
            isMakeUpSession || isExcludedFromPayroll || isExcludedFromMileage || isRBTTracking ? _react2.default.createElement('i', { title: ('' + (isMakeUpSession ? 'Make-Up Session\n' : '') + (isExcludedFromPayroll ? 'Excluded From Payroll\n' : '') + (isExcludedFromMileage ? 'Excluded From Mileage\n' : '') + (isRBTTracking ? 'RBT Supervision' : '')).trim(), className: 'fa fa-info-circle icon-background1', 'aria-hidden': 'true' }) : '',
            appointmentNotes ? _react2.default.createElement('i', { title: '' + appointmentNotes, className: 'fa fa-file-text-o', 'aria-hidden': 'true' }) : ''
          ),
          staffs ? this.renderStaffs(staffs) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'info-pic' },
              clinicianImage ? _react2.default.createElement('img', { src: clinicianImage, width: '80px', height: '80px', onClick: function onClick(e) {
                  return hoverDialogActions(event, e, 'view_profile');
                } }) : clinicianName ? clinicianName.split(' ').length > 1 ? _react2.default.createElement(
                'span',
                { className: 'userletter' },
                clinicianName.split(' ')[0][0].toUpperCase() + clinicianName.split(' ')[clinicianName.split(' ').length - 1][0].toUpperCase()
              ) : _react2.default.createElement(
                'span',
                { className: 'userletter' },
                clinicianName[0].toUpperCase()
              ) : ''
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-p' },
              _react2.default.createElement(
                'div',
                { className: 'name', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'view_profile');
                  } },
                clinicianName
              ),
              _react2.default.createElement(
                'a',
                { href: '#', onClick: function onClick(e) {
                    return hoverDialogActions(event, e, 'soap_note');
                  } },
                soapNoteTitle
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'about-event' },
          _react2.default.createElement(
            'div',
            { className: 'info-p' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement('i', { className: 'fa fa-clock-o', 'aria-hidden': 'true' }),
              _react2.default.createElement(
                'span',
                null,
                appointmentTime
              )
            ),
            practitionerName ? _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement('i', { className: 'fa fa-user', 'aria-hidden': 'true' }),
              _react2.default.createElement(
                'span',
                null,
                practitionerName
              )
            ) : '',
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement('i', { className: 'fa fa-calendar-o', 'aria-hidden': 'true' }),
              _react2.default.createElement(
                'span',
                null,
                appointmentType
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'span',
                null,
                isBillable === true ? 'Billable' : 'Non-billable'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement('i', { className: 'fa fa-map-marker', 'aria-hidden': 'true' }),
              _react2.default.createElement(
                'span',
                null,
                appointmentAddress
              )
            )
          )
        )
      )
    );
  };

  return AppointmentBox;
}(_react2.default.Component);

AppointmentBox.propTypes = propTypes;

exports.default = AppointmentBox;


//////////////////
// WEBPACK FOOTER
// ./~/@aksharma25/react-schedulers-theralytics/lib/AppointmentBox.js
// module id = 915
// module chunks = 0